import React, { useState, useEffect } from 'react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';
import serviceManagementService from '../../../services/serviceManagementService';

const PackageCreationModal = ({ package: pkg, onClose, onSave, countries = [] }) => {

  const [formData, setFormData] = useState({
    packageName: '',
    packageCode: '',
    tier: 'silver',
    description: '',
    basePrice: '',
      designFee: '', 
    discountPercentage: '0',
    finalPrice: '',
    includedUnits: '',
    additionalUnitPrice: '',
    status: 'active',
    countryId: '',
    serviceIds: []
  });
  const [availableServices, setAvailableServices] = useState([]);
  const [loadingServices, setLoadingServices] = useState(true);

  useEffect(() => {
    fetchServices();
  }, []);

  const getCurrencySymbol = (currencyCode) => {
    const currencySymbols = {
      // Major Currencies
      'EUR': '€',      // Euro
      'USD': '$',      // US Dollar
      'GBP': '£',      // British Pound
      'JPY': '¥',      // Japanese Yen
      'CHF': 'Fr',     // Swiss Franc
      'CAD': 'C$',     // Canadian Dollar
      'AUD': 'A$',     // Australian Dollar
      'NZD': 'NZ$',    // New Zealand Dollar
      'CNY': '¥',      // Chinese Yuan
      'HKD': 'HK$',    // Hong Kong Dollar
      'SGD': 'S$',     // Singapore Dollar
      
      'TND': 'DT',      // Dinar tunisien
      'MAD': 'MAD',     // Dirham marocain
      'DZD': 'DZD',     // Dinar algérien
      'AED': 'AED',     // Dirham des Émirats arabes unis
      'SAR': 'SAR',     // Riyal saoudien
      'QAR': 'QAR',     // Riyal qatari
      'KWD': 'KWD',     // Dinar koweïtien
      'BHD': 'BHD',     // Dinar bahreïni
      'OMR': 'OMR',     // Rial omanais
      'JOD': 'JOD',     // Dinar jordanien
      'LBP': 'LBP',     // Livre libanaise
      'EGP': 'EGP',     // Livre égyptienne
      'IQD': 'IQD',     // Dinar irakien
      'SYP': 'SYP',     // Livre syrienne
      'YER': 'YER',     // Rial yéménite
      'LYD': 'LYD',     // Dinar libyen
      
      // Europe
      'NOK': 'kr',     // Norwegian Krone
      'SEK': 'kr',     // Swedish Krona
      'DKK': 'kr',     // Danish Krone
      'ISK': 'kr',     // Icelandic Króna
      'CZK': 'Kč',     // Czech Koruna
      'PLN': 'zł',     // Polish Zloty
      'HUF': 'Ft',     // Hungarian Forint
      'RON': 'lei',    // Romanian Leu
      'BGN': 'лв',     // Bulgarian Lev
      'HRK': 'kn',     // Croatian Kuna
      'RSD': 'дин',    // Serbian Dinar
      'UAH': '₴',      // Ukrainian Hryvnia
      'RUB': '₽',      // Russian Ruble
      'BYN': 'Br',     // Belarusian Ruble
      'TRY': '₺',      // Turkish Lira
      'GEL': '₾',      // Georgian Lari
      'AMD': '֏',      // Armenian Dram
      'AZN': '₼',      // Azerbaijani Manat
      
      // Americas
      'MXN': 'Mex$',   // Mexican Peso
      'BRL': 'R$',     // Brazilian Real
      'ARS': '$',      // Argentine Peso
      'CLP': '$',      // Chilean Peso
      'COP': '$',      // Colombian Peso
      'PEN': 'S/',     // Peruvian Sol
      'UYU': '$U',     // Uruguayan Peso
      'VES': 'Bs.',    // Venezuelan Bolívar
      'BOB': 'Bs',     // Bolivian Boliviano
      'PYG': '₲',      // Paraguayan Guaraní
      'CRC': '₡',      // Costa Rican Colón
      'GTQ': 'Q',      // Guatemalan Quetzal
      'HNL': 'L',      // Honduran Lempira
      'NIO': 'C$',     // Nicaraguan Córdoba
      'PAB': 'B/.',    // Panamanian Balboa
      'DOP': 'RD$',    // Dominican Peso
      'JMD': 'J$',     // Jamaican Dollar
      'TTD': 'TT$',    // Trinidad and Tobago Dollar
      'BSD': 'B$',     // Bahamian Dollar
      'BBD': 'Bds$',   // Barbadian Dollar
      'XCD': 'EC$',    // East Caribbean Dollar
      
      // Asia
      'INR': '₹',      // Indian Rupee
      'PKR': '₨',      // Pakistani Rupee
      'BDT': '৳',      // Bangladeshi Taka
      'LKR': 'Rs',     // Sri Lankan Rupee
      'NPR': 'Rs',     // Nepalese Rupee
      'MVR': 'Rf',     // Maldivian Rufiyaa
      'AFN': '؋',      // Afghan Afghani
      'KRW': '₩',      // South Korean Won
      'KPW': '₩',      // North Korean Won
      'TWD': 'NT$',    // Taiwan Dollar
      'THB': '฿',      // Thai Baht
      'MYR': 'RM',     // Malaysian Ringgit
      'IDR': 'Rp',     // Indonesian Rupiah
      'PHP': '₱',      // Philippine Peso
      'VND': '₫',      // Vietnamese Dong
      'LAK': '₭',      // Lao Kip
      'KHR': '៛',      // Cambodian Riel
      'MMK': 'K',      // Myanmar Kyat
      'BND': 'B$',     // Brunei Dollar
      'MNT': '₮',      // Mongolian Tugrik
      'KZT': '₸',      // Kazakhstani Tenge
      'UZS': 'som',   // Uzbekistani Som
      'KGS': 'с',      // Kyrgyzstani Som
      'TJS': 'ЅМ',     // Tajikistani Somoni
      'TMT': 'm',      // Turkmenistani Manat
      
      // Africa
      'ZAR': 'R',      // South African Rand
      'NGN': '₦',      // Nigerian Naira
      'KES': 'KSh',    // Kenyan Shilling
      'GHS': '₵',      // Ghanaian Cedi
      'TZS': 'TSh',    // Tanzanian Shilling
      'UGX': 'USh',    // Ugandan Shilling
      'ETB': 'Br',     // Ethiopian Birr
      'ZMW': 'ZK',     // Zambian Kwacha
      'MWK': 'MK',     // Malawian Kwacha
      'RWF': 'FRw',    // Rwandan Franc
      'BIF': 'FBu',    // Burundian Franc
      'SOS': 'Sh',     // Somali Shilling
      'DJF': 'Fdj',    // Djiboutian Franc
      'ERN': 'Nfk',    // Eritrean Nakfa
     
      'SSP': '£',      // South Sudanese Pound
      'AOA': 'Kz',     // Angolan Kwanza
      'MZN': 'MT',     // Mozambican Metical
      'BWP': 'P',      // Botswanan Pula
      'NAD': 'N$',     // Namibian Dollar
      'SZL': 'E',      // Swazi Lilangeni
      'LSL': 'L',      // Lesotho Loti
      'MGA': 'Ar',     // Malagasy Ariary
      'MUR': '₨',      // Mauritian Rupee
      'SCR': '₨',      // Seychellois Rupee
      'KMF': 'CF',     // Comorian Franc
      'CDF': 'FC',     // Congolese Franc
      'XAF': 'FCFA',   // Central African CFA Franc
      'XOF': 'CFA',    // West African CFA Franc
      'GNF': 'FG',     // Guinean Franc
      'SLL': 'Le',     // Sierra Leonean Leone
      'LRD': 'L$',     // Liberian Dollar
      'GMD': 'D',      // Gambian Dalasi
      'CVE': '$',      // Cape Verdean Escudo
      'STN': 'Db',     // São Tomé and Príncipe Dobra
      
      // Oceania
      'FJD': 'FJ$',    // Fijian Dollar
      'PGK': 'K',      // Papua New Guinean Kina
      'SBD': 'SI$',    // Solomon Islands Dollar
      'VUV': 'VT',     // Vanuatu Vatu
      'WST': 'WS$',    // Samoan Tala
      'TOP': 'T$',     // Tongan Paʻanga
      'XPF': '₣',      // CFP Franc (French Pacific)
      
      // Cryptocurrencies
      'BTC': '₿',      // Bitcoin
      'ETH': 'Ξ',      // Ethereum
   
  
    
    };
    
    return currencySymbols[currencyCode] || currencyCode || '€';
  };
  useEffect(() => {
  if (formData?.countryId) {
    fetchServices();
    // Optionnel: réinitialiser les services sélectionnés
    // setFormData(prev => ({ ...prev, serviceIds: [] }));
  }
}, [formData?.countryId]);

  useEffect(() => {
    if (pkg) {
      setFormData({
        packageName: pkg?.packageName || '',
        packageCode: pkg?.packageCode || '',
        tier: pkg?.tier || 'silver',
        description: pkg?.description || '',
            designFee: pkg?.designFee?.toString() || '', 
        basePrice: pkg?.basePrice?.toString() || '',
        discountPercentage: pkg?.discountPercentage?.toString() || '0',
        finalPrice: pkg?.finalPrice?.toString() || '',
        includedUnits: pkg?.includedUnits?.toString() || '',
        additionalUnitPrice: pkg?.additionalUnitPrice?.toString() || '',
        status: pkg?.status || 'active',
        countryId: pkg?.countryId || '',
        serviceIds: pkg?.services?.map(s => s?.id) || []
      });
    }
  }, [pkg]);

  // Auto-calculate final price when base price or discount changes
  useEffect(() => {
    if (formData?.basePrice && formData?.discountPercentage) {
      const base = parseFloat(formData?.basePrice);
      const discount = parseFloat(formData?.discountPercentage);
      const final = base - (base * discount / 100);
      setFormData(prev => ({ ...prev, finalPrice: final?.toFixed(2) }));
    }
  }, [formData?.basePrice, formData?.discountPercentage]);
const fetchServices = async () => {
  try {
    setLoadingServices(true);
    if (!formData?.countryId) {
      setAvailableServices([]);
      return;
    }
    const availability = await serviceManagementService.getServiceAvailabilityByCountry(
      formData.countryId,
    );
    const mapped = (availability || [])
      .filter((row) => row.isAvailable)
      .map((row) => ({
        id: row.serviceId,
        serviceName: row.serviceName,
        serviceCode: row.serviceCode,
        category: row.category,
        unitPrice:
          row.customPrice != null && row.customPrice !== ''
            ? Number(row.customPrice)
            : Number(row.basePrice) || 0,
        isActive: true,
      }));
    setAvailableServices(mapped);
  } catch (error) {
    console.error('Error fetching services:', error);
    setAvailableServices([]);
  } finally {
    setLoadingServices(false);
  }
};

  const tierOptions = [
    { value: 'bronze', label: 'Bronze - Starter' },
    { value: 'silver', label: 'Silver - Standard' },
    { value: 'gold', label: 'Gold - Premium' }
  ];

  const statusOptions = [
    { value: 'active', label: 'Actif' },
    { value: 'inactive', label: 'Inactif' },
    { value: 'archived', label: 'Archivé' }
  ];

  const countryOptions = [
    { value: '', label: 'Sélectionner un pays' },
    ...countries?.map(country => ({
      value: country?.id,
      label: `${country?.countryName} (${country?.countryCode})`
    }))
  ];

  const handleServiceToggle = (serviceId) => {
    setFormData(prev => ({
      ...prev,
      serviceIds: prev?.serviceIds?.includes(serviceId)
        ? prev?.serviceIds?.filter(id => id !== serviceId)
        : [...prev?.serviceIds, serviceId]
    }));
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    
    // Validate required numeric fields
    const basePrice = parseFloat(formData?.basePrice);
    const finalPrice = parseFloat(formData?.finalPrice);
    const includedUnits = parseInt(formData?.includedUnits);
    const discountPercentage = parseInt(formData?.discountPercentage);
    
    // Check for invalid values
    if (isNaN(basePrice) || basePrice <= 0) {
      alert('Veuillez entrer un prix de base valide');
      return;
    }
    
    if (isNaN(finalPrice) || finalPrice <= 0) {
      alert('Veuillez entrer un prix final valide');
      return;
    }
    
    if (isNaN(includedUnits) || includedUnits <= 0) {
      alert('Veuillez entrer un nombre d\'unités incluses valide');
      return;
    }
    
    if (isNaN(discountPercentage) || discountPercentage < 0 || discountPercentage > 100) {
      alert('Veuillez entrer un pourcentage de remise valide (0-100)');
      return;
    }
    
    // Parse additional unit price (optional field)
    const additionalUnitPrice = formData?.additionalUnitPrice 
      ? parseFloat(formData?.additionalUnitPrice) 
      : null;
    const designFee = formData?.designFee 
  ? parseFloat(formData?.designFee) 
  : null;
    // Validate additional unit price if provided
    if (formData?.additionalUnitPrice && (isNaN(additionalUnitPrice) || additionalUnitPrice < 0)) {
      alert('Veuillez entrer un prix unitaire additionnel valide');
      return;
    }
    if (formData?.designFee && (isNaN(designFee) || designFee < 0)) {
  alert('Veuillez entrer des frais de conception valides');
  return;
}
    
    onSave({
      ...formData,
      basePrice,
      discountPercentage,
      finalPrice,
      includedUnits,
      additionalUnitPrice,
       designFee 
    });
  };
   const selectedCountry = countries?.find(c => c?.id === formData?.countryId);
  const currencySymbol = getCurrencySymbol(selectedCountry?.currencyCode);
 
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 animate-fade-in">
      <div className="bg-card rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-hidden animate-slide-in">
        <div className="flex items-center justify-between p-6 border-b border-border">
          <h2 className="text-2xl font-bold text-foreground">
            {pkg ? 'Modifier le Pack' : 'Créer un Pack'}
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 overflow-y-auto max-h-[calc(90vh-140px)]">
          <div className="space-y-6">
            {/* Basic Information */}
            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-foreground flex items-center gap-2">
                <Icon name="Package" size={20} />
                Informations de base
              </h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Input
                  label="Nom du pack"
                  type="text"
                  required
                  value={formData?.packageName}
                  onChange={(e) => setFormData({ ...formData, packageName: e?.target?.value })}
                  placeholder="Ex: Pack Premium"
                />
                
                <Input
                  label="Code du pack"
                  type="text"
                  required
                  value={formData?.packageCode}
                  onChange={(e) => setFormData({ ...formData, packageCode: e?.target?.value })}
                  placeholder="Ex: PKG-001"
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <Select
                  label="Niveau"
                  options={tierOptions}
                  value={formData?.tier}
                  onChange={(value) => setFormData({ ...formData, tier: value })}
                  required
                />
                
                <Select
                  label="Statut"
                  options={statusOptions}
                  value={formData?.status}
                  onChange={(value) => setFormData({ ...formData, status: value })}
                  required
                />

                <Select
                  label="Pays"
                  options={countryOptions}
                  value={formData?.countryId}
                  onChange={(value) => setFormData({ ...formData, countryId: value })}
                  placeholder="Sélectionner un pays"
                />
              </div>

              <div className="mt-4">
                <Input
                  label="Description"
                  required
                  value={formData?.description}
                  onChange={(e) => setFormData({ ...formData, description: e?.target?.value })}
                  placeholder="Solution orthodontique standard avec suivi personnalisé"
                />
              </div>
            </div>

            {/* Pricing */}
            <div>
              <h3 className="text-lg font-semibold text-foreground mb-4">Tarification</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Input
                  label={`Prix de base (${currencySymbol})`}
                  type="number"
                  step="0.01"
                  required
                  value={formData?.basePrice}
                  onChange={(e) => setFormData({ ...formData, basePrice: e?.target?.value })}
                  placeholder="1890.00"
                />

                <Input
                  label="Remise (%)"
                  type="number"
                  min="0"
                  max="100"
                  value={formData?.discountPercentage}
                  onChange={(e) => setFormData({ ...formData, discountPercentage: e?.target?.value })}
                  placeholder="10"
                />

                <Input
                  label={`Prix final (${currencySymbol})`}
                  type="number"
                  step="0.01"
                  required
                  value={formData?.finalPrice}
                  onChange={(e) => setFormData({ ...formData, finalPrice: e?.target?.value })}
                  placeholder="1701.00"
                  disabled
                />
                <Input
  label={`Frais de conception (${currencySymbol})`}
  type="number"
  step="0.01"
  value={formData?.designFee}
  onChange={(e) => setFormData({ ...formData, designFee: e?.target?.value })}
  placeholder="150.00"
/>

                <Input
                  label={`Prix unitaire additionnel (${currencySymbol})`}
                  type="number"
                  step="0.01"
                  value={formData?.additionalUnitPrice}
                  onChange={(e) => setFormData({ ...formData, additionalUnitPrice: e?.target?.value })}
                  placeholder="35.00"
                />
              </div>
            </div>

            {/* Units */}
            <div>
              <h3 className="text-lg font-semibold text-foreground mb-4">Unités</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Input
                  label="Unités incluses"
                  type="number"
                  required
                  value={formData?.includedUnits}
                  onChange={(e) => setFormData({ ...formData, includedUnits: e?.target?.value })}
                  placeholder="100"
                />
              </div>
            </div>

            {/* Services Selection */}
            <div>
              <h3 className="text-lg font-semibold text-foreground mb-4">Services inclus</h3>
              {loadingServices ? (
                <div className="text-center py-8 text-muted-foreground">
                  <Icon name="Loader2" size={24} className="animate-spin mx-auto mb-2" />
                  <p>Chargement des services...</p>
                </div>
              ) : availableServices?.length === 0 ? (
                <div className="text-center py-8 text-muted-foreground">
                  <Icon name="AlertCircle" size={24} className="mx-auto mb-2" />
                  <p>Aucun service disponible</p>
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  {availableServices?.map((service) => (
                    <div
                      key={service?.id}
                      className="flex items-start gap-3 p-4 bg-muted/30 rounded-lg hover:bg-muted/50 transition-colors cursor-pointer"
                      onClick={() => handleServiceToggle(service?.id)}
                    >
                      <Checkbox
                        checked={formData?.serviceIds?.includes(service?.id)}
                        onChange={() => handleServiceToggle(service?.id)}
                      />
                      <div className="flex-1">
                        <div className="flex items-center justify-between">
                          <h4 className="font-medium text-foreground">{service?.serviceName}</h4>
                          <span className="text-sm font-semibold text-primary">
                            {service?.unitPrice?.toFixed(2)} ({currencySymbol})
                          </span>
                        </div>
                        <p className="text-sm text-muted-foreground mt-1">{service?.description}</p>
                        <span className="inline-block mt-2 px-2 py-1 text-xs rounded-full bg-primary/10 text-primary">
                          {service?.category}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Selected Services Summary */}
            {formData?.serviceIds?.length > 0 && (
              <div className="bg-primary/5 border border-primary/20 rounded-lg p-4">
                <h4 className="font-semibold text-foreground mb-2">
                  Services sélectionnés ({formData?.serviceIds?.length})
                </h4>
                <div className="flex flex-wrap gap-2">
                  {formData?.serviceIds?.map((serviceId) => {
                    const service = availableServices?.find(s => s?.id === serviceId);
                    return service ? (
                      <span
                        key={serviceId}
                        className="inline-flex items-center gap-1 px-3 py-1 bg-primary/10 text-primary rounded-full text-sm"
                      >
                        <Icon name="Check" size={14} />
                        {service?.serviceName}
                      </span>
                    ) : null;
                  })}
                </div>
              </div>
            )}
          </div>

          <div className="flex items-center justify-end gap-3 p-6 border-t border-border bg-muted/30">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
            >
              Annuler
            </Button>
            <Button
              type="submit"
              variant="default"
              iconName="Save"
            >
              {pkg ? 'Mettre à jour' : 'Créer le pack'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PackageCreationModal;